import { NavLink } from "react-router-dom";
import { Home, ShoppingBag, MapPin, Heart, User } from "lucide-react";

const ITEMS = [
  { to: "/", icon: Home, label: "Home", end: true },
  { to: "/shop", icon: ShoppingBag, label: "Shop" },
  { to: "/local", icon: MapPin, label: "Near Me" },
  { to: "/account", icon: Heart, label: "Saved" },
  { to: "/account", icon: User, label: "Account" },
];

export default function MobileNav() {
  return (
    <nav className="md:hidden fixed bottom-0 inset-x-0 z-40 bg-white border-t border-stone-200 grain" data-testid="mobile-bottom-nav">
      <div className="grid grid-cols-5">
        {ITEMS.map((it, i) => (
          <NavLink key={i} to={it.to} end={it.end}
            className={({ isActive }) => `flex flex-col items-center gap-0.5 py-2.5 text-[10px] font-semibold ${isActive ? "text-[var(--friib)]" : "text-stone-500"}`}>
            <it.icon size={20} /> {it.label}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
